var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 141,
    viewBox: "0 0 256 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 141
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 141,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243 128C243 112.898 240.025 97.9438 234.246 83.9914C228.467 70.039 219.996 57.3615 209.317 46.6827C198.639 36.004 185.961 27.5331 172.009 21.7539C158.056 15.9746 143.102 13 128 13C112.898 13 97.9438 15.9746 83.9914 21.7539C70.039 27.5331 57.3615 36.004 46.6827 46.6827C36.004 57.3615 27.5331 70.039 21.7539 83.9914C15.9746 97.9438 13 112.898 13 128",
    stroke: "#1E3927",
    strokeWidth: 26,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.246 83.9914C228.467 70.039 219.996 57.3615 209.317 46.6827C198.639 36.004 185.961 27.5331 172.009 21.7539C158.056 15.9746 143.102 13 128 13C112.898 13 97.9438 15.9746 83.9914 21.7539C70.039 27.5331 57.3615 36.004 46.6827 46.6827C36.004 57.3615 27.5331 70.039 21.7539 83.9914C15.9746 97.9439 13 112.898 13 128",
    stroke: "#6DB231",
    strokeWidth: 26,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e0d9b616972832b8af2d00dd3c350494.svg";
export { ForwardRef as ReactComponent };